<template>
    <div class="d-flex mb-3" v-if="formLocked == true">
        <button type="button" class="btn btn-info btn-sm mr-2" @click="switchStatutModif()">
            <i class="fas fa-edit"></i> Modifier
        </button>
        <button type="button" class="btn btn-danger btn-sm mr-2" @click.prevent="deleteLine()">
            <i class="fas fa-trash-alt"></i> Supprimer
        </button>
    </div>
    <FormVille :key="key" :formLocked="formLocked" :line="datas" v-on:line_updated="switchStatutModif"></FormVille>
</template>

<script>
import $ from "jquery"
import { defineComponent, defineAsyncComponent } from 'vue';
const FormVille = defineAsyncComponent(() => import('./FormVille.vue'));

export default defineComponent({
    name: 'ShowVille',
    inject: ['dialogRef'],
    components: { FormVille },
    data() {
        return {
            key: 1,
            table: 'villes',
            isLoading: false,
            datas: this.dialogRef.data,
            formLocked: true,
            baseUrl: this.$store.state.api_yams_livraisons,
        }
    },
    methods: {
        switchStatutModif() {
            this.key++
            if (this.formLocked == false) {
                this.formLocked = true
            }
            else this.formLocked = false
        },
        deleteLine() {
            if (!window.confirm("Etes vous sur de vouloir supprimer ?")) {
                return
            }
            this.isLoading = true
            this.axios.post('/api/microservice/api-courses/'+this.table+'/' + this.datas.id + '/destroy').then((response) => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    this.dialogRef.close()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                }
                else {
                    response.data.errors.forEach(element => {
                        this.$toast.add({
                            severity: 'warn',
                            summary: 'Oups !',
                            detail: element,
                            life: 20000
                        });
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        }
    }
})
</script>